import React from 'react';
import { Deal } from '@upstart/harmony/lib/legos/dealTypes';
import './LendingSupport.scss';

interface Props {
  deal: Deal;
}

export const LendingSupportDataDogLinks: React.FC<Props> = React.memo(
  ({ deal }) => {
    const dealId = deal.id;
    const ddBaseUrl = 'https://upstart.datadoghq.com';
    const oneWeekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
    const currentTime = Date.now();

    const createTracesUrl = (): string => {
      const url = new URL(`${ddBaseUrl}/apm/traces`);
      url.searchParams.set('query', `@dealId:${dealId}`);
      url.searchParams.set('start', oneWeekAgo.toString());
      url.searchParams.set('end', currentTime.toString());
      return url.toString();
    };

    const createRumSessionsUrl = (): string => {
      const url = new URL(`${ddBaseUrl}/rum/sessions`);
      url.searchParams.set(
        'query',
        `@type:view @view.url_path:/deals/financing/${dealId}`,
      );
      url.searchParams.set('from_ts', oneWeekAgo.toString());
      url.searchParams.set('to_ts', currentTime.toString());
      url.searchParams.set('live', 'true');
      return url.toString();
    };

    return (
      <>
        <div>DataDog Links</div>
        <a href={createTracesUrl()} target="_blank" rel="noreferrer">
          Traces
        </a>
        <div />
        <a href={createRumSessionsUrl()} target="_blank" rel="noreferrer">
          RUM Sessions
        </a>
      </>
    );
  },
);
